import { render, staticRenderFns } from "./HotUpdate.vue?vue&type=template&id=24980310&scoped=true&"
import script from "./HotUpdate.vue?vue&type=script&lang=js&"
export * from "./HotUpdate.vue?vue&type=script&lang=js&"
import style0 from "./HotUpdate.vue?vue&type=style&index=0&id=24980310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24980310",
  null
  
)

export default component.exports